import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Text, HtmlText } from 'ilenia';
import { Common } from '../../Assets/styles/common';
import * as images from '../../Assets/images/svg';
import { TooltipIconType, TooltipType, TooltipSettings } from '../../Model';

interface TooltipProps extends React.HTMLProps<HTMLLabelElement> {
    tooltipSettings: TooltipSettings;
}

export const Tooltip: React.SFC<TooltipProps> = (props) => {
    const { tooltipSettings } = props;
    const Icon = () => {
        return tooltipSettings.iconType === TooltipIconType.ripple ? <images.ripple/> : <images.questionMark/>;
    };

    const TooltipByType = () => {
        return tooltipSettings.type === TooltipType.html ?
            <HtmlText id={tooltipSettings.text} interpolations={tooltipSettings.interpolations!}/> :
            <Text id={tooltipSettings.text} interpolations={tooltipSettings.interpolations}/>;
    };

    return (
        <div className={css(styles.container, styles.containerHover)}>
            <Icon/>
            <div className={css(styles.tooltip, tooltipSettings.iconType === TooltipIconType.ripple && styles.tooltipRipple)}>
                <div className={css(styles.arrow, styles.arrowPseudo)}/>
                <div>
                    <TooltipByType/>
                </div>
            </div>
        </div>
    );
};

const styles = StyleSheet.create({
    container: {
        display: 'inline-flex',
        verticalAlign: 'middle',
        paddingLeft: '7px',
        position: 'relative',
        alignItems: 'center'
    },
    containerHover: {
        ':hover > div': {
            display: 'inline-block',
        }
    },
    tooltip: {
        width: '310px',
        minHeight: '50px',
        boxShadow: Common.Borders.boxShadowHover,
        backgroundColor: '#ffffff',
        border: 'solid 1px #dfe2e5',
        position: 'absolute',
        padding: '16px',
        boxSizing: 'border-box',
        display: 'none',
        marginLeft: '35px',
        zIndex: 10000,
        font: Common.Font.normalText,
        alignSelf: 'center'
    },
    tooltipRipple: {
        marginLeft: '75px',
    },
    arrow: {
        width: '50px',
        height: '24px',
        position: 'absolute',
        top: 'calc(50% - 12px)',
        left: '-10px',
        transform: 'translateX(-27px) rotate(90deg)',
        overflow: 'hidden',
    },
    arrowPseudo: {
        ':after': {
            content: '""',
            position: 'absolute',
            width: '20px',
            height: '20px',
            background: 'white',
            transform: 'translateX(-50%) translateY(-50%) rotate(45deg) skewX(10deg) skewY(10deg)',
            top: '0',
            left: '50%',
            boxShadow: '2px 0px 4px 0 rgba(0, 0, 0, 0.25)',
            border: 'solid 1px #dfe2e5',
        },
    }
});



// WEBPACK FOOTER //
// ./src/CommonUI/UI/Tooltip.tsx